// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__PF4Vr","slider":"Toggle_slider__lFWBJ","toggleInput":"Toggle_toggleInput__XQpUu","small":"Toggle_small__jblJ4"};